const SESSION_ID_KEY = "ha-session-id";

/**
 * A stable per-browser-session id used to correlate frontend telemetry with
 * backend traces/logs (sent as the `x-session-id` header / `session_id` query
 * param, and as a `session.id` telemetry attribute). Generated once and kept in
 * `sessionStorage`.
 *
 * Returns `undefined` during SSR (no `sessionStorage`) or when storage is
 * unavailable (e.g. privacy mode) — correlation is best-effort.
 */
export function getSessionId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    let id = window.sessionStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      window.sessionStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    return undefined;
  }
}
